/* eslint-disable max-lines */
/**
 * Google analytics.
 * In all the pages <head> Google analytics js script must be included from Tools Library.
 * example - https://www.philips.com/a1l4rgpa1fx2crzaqh/t1l6vgru59xvprnlz0ll.js
 */

const gaclkFn = {};


gaclkFn.variables = {
  orderHistoryClass: '.ph-orderhistory_title',
  orderHistoryPanelClass: '.ph-orderhistory_panel'
};

gaclkFn.ordersInteractionEventsClicks = (eventTarget) => {
  const trackingClassList = [
    {
      className: '.ph-orders-click',
      fn: 'accountNavigationOrders'
    },
    {
      className: '.ph-orderhistory_paneltitle.ph-icon-arrow-up',
      fn: 'orderDetailView'
    },
    {
      className: '.ph-orderhistory_paneltitle.ph-icon-arrow-down',
      fn: 'orderDetailViewClose'
    },
    {
      className: '.ga-accordion-click.ph-icon-arrow-down',
      fn: 'orderDetailViewClose'
    },
    {
      className: '.ph-os-addressArrow.ph-icon-arrow-down',
      fn: 'addressDetailViewClose'
    },
    {
      className: '.ph-os-addressArrow.ph-icon-arrow-up',
      fn: 'addressDetailViewOpen'
    },
    {
      className: '.ph-orderhistory__offlinesearch',
      fn: 'orderSearchNavigation'
    },
    {
      className: '.ph-download-invoice',
      fn: 'orderDetailInvoiceDownload'
    },
    {
      className: '.ph-osRmddetails',
      fn: 'orderDetailRMDPopup'
    },

    {
      className: '.invoice-link',
      fn: 'orderDetailInvoiceDownload'
    },
    {
      className: '.ph__selfinvoiceno__click',
      fn: 'orderDetailInvoiceDownload'
    },
    {
      className: '.ph-os-invoiceUrl',
      fn: 'orderDetailInvoiceDownload'
    },
    {
      className: '.packing-link',
      fn: 'orderDetailPackingListeDownload'
    },
    {
      className: '.ph-download-rmd',
      fn: 'orderDetailRMDDownload'
    },
    {
      className: '.ph-sorting__itemtext',
      fn: 'clickOnSort'
    },
    {
      className: '.ph-OH_sorting__itemtext',
      fn: 'clickOnSort'
    },
    {
      className: '.ph-myOrders',
      fn: 'orderPlacedByMeCheck'
    },
    {
      className: '.ph-placedByMeCheckbox',
      fn: 'orderHistoryCheckbox'
    },
    {
      className: '.ph-myApprovalOrders',
      fn: 'orderHistoryCheckbox'
    },
    {
      className: '.ph-printicon-image.ph-print-order',
      fn: 'orderPrint'
    },
    {
      className: '.ph-orderhistory_prodname',
      fn: 'orderProductClick'
    },
    {
      className: '.ph-orderhistory_prodimg',
      fn: 'orderProductClick'
    },
    {
      className: '.ph-os_prodDetails',
      fn: 'orderProductClick'
    },
    {
      className: '.ph-orderhistory_reorder',
      fn: 'orderReorderBtnClick'
    },
    {
      className: '.ph-orderhistory_return',
      fn: 'orderReturn'
    },
    {
      className: '.ph-lazyload-tracking',
      fn: 'orderTrackClick'
    },
    {
      className: '.ph-os-trackingUrl',
      fn: 'orderTrackClick'
    },
    {
      className: '.ph-orderhistory_approve',
      fn: 'orderApproval'
    },
    {
      className: '.ph-onestore__approve',
      fn: 'orderApproval'
    },
    {
      className: '.ph-onestore__reject',
      fn: 'orderApproval'
    },
    {
      className: '.ph-orderhistory_reject',
      fn: 'orderApproval'
    }
  ];

  trackingClassList.forEach((classObject) => {
    if (eventTarget.closest(classObject.className)) {
      gaclkFn[classObject.fn](eventTarget);
    }
  });
};

gaclkFn.accountNavigationOrders = (eventTarget) => {
  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'accountNavigationOrders',
    componentType: 'link',
    interaction: {
      goal: 'account navigation Orders',
      description: 'Order history navigation',
      interactive: true
    }
  };

  clickEventInfo.interaction.status = 'success';
  clickEventInfo.interaction.url = eventTarget.getAttribute('href');
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};
gaclkFn.orderDetailView = (eventTarget) => {
  let eddlAction = {},
      orderId = '';
  const clickEventInfo = {
    triggerName: 'orderDetailView',
    componentType: 'accordion',
    interaction: {
      goal: 'Open order detail view',
      description: 'View order details open',
      interactive: true
    }
  };

  orderId = gaclkFn.orderIdfromEventTarget(eventTarget);
  clickEventInfo.interaction.value = orderId.trim();
  clickEventInfo.interaction.id = orderId.trim();
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.OneStoreOrderDetailView = (eventTarget, properties) => {
  let eddlAction = {},
      orderId = '';
  const productsArray = gaclkFn.orderHistoryIteration(eventTarget, properties);

  const ecommerEvent = {
    products: productsArray
  };

  const clickEventInfo = {
    triggerName: 'orderDetailView',
    componentType: 'accordion',
    interaction: {
      goal: 'Open order detail view',
      description: 'View order details open',
      interactive: true
    }
  };

  orderId = properties.code;
  clickEventInfo.interaction.value = orderId.trim();
  clickEventInfo.interaction.productsDetailsData = ecommerEvent;
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderDetailViewClose = (eventTarget) => {
  let eddlAction = {},
      orderId = '';
  const clickEventInfo = {
    triggerName: 'orderDetailViewClose',
    componentType: 'accordion',
    interaction: {
      goal: 'Close order detail view',
      description: 'View order details close',
      interactive: true
    }
  };

  orderId = gaclkFn.orderIdfromEventTarget(eventTarget);
  clickEventInfo.interaction.value = orderId.trim();
  clickEventInfo.interaction.id = orderId.trim();
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.addressDetailViewClose = (eventTarget) => {
  let eddlAction = {};

  const clickEventInfo = {
    triggerName: 'addressDetailViewClose',
    componentType: 'accordion',
    interaction: {
      goal: 'Close address detail view',
      description: 'View address details close',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = eventTarget.getAttribute('data-subOrderId');
  clickEventInfo.interaction.id = eventTarget.getAttribute('data-subOrderId');
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.addressDetailViewOpen = (eventTarget) => {
  let eddlAction = {};

  const clickEventInfo = {
    triggerName: 'addressDetailViewOpen',
    componentType: 'accordion',
    interaction: {
      goal: 'Open address detail view',
      description: 'View address details Open',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = eventTarget.getAttribute('data-subOrderId');
  clickEventInfo.interaction.id = eventTarget.getAttribute('data-subOrderId');
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderSearchNavigation = (eventTarget) => {
  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'orderSearchNavigation',
    componentType: 'link',
    interaction: {
      goal: 'order search navigation',
      description: 'Order search',
      interactive: true
    }
  };

  clickEventInfo.interaction.status = 'success';
  clickEventInfo.interaction.url = eventTarget.getAttribute('href');
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderDetailInvoiceDownload = (eventTarget) => {
  let eddlAction = {},
      orderId = '';
  const clickEventInfo = {
    triggerName: 'orderDetailInvoiceDownload',
    componentType: 'accordion',
    interaction: {
      goal: 'order detail invoice download',
      description: 'Order history - download invoice',
      interactive: true
    }
  };

  if (eventTarget.className === 'ph-os-invoiceUrl' === true) {
    clickEventInfo.interaction.value = eventTarget.getAttribute('data-suborderNumber');
    clickEventInfo.interaction.id = eventTarget.getAttribute('data-suborderNumber');
  } else {
    orderId = gaclkFn.orderIdfromEventTarget(eventTarget);
    clickEventInfo.interaction.value = eventTarget.textContent.trim();
    clickEventInfo.interaction.id = orderId.trim();
  }

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderDetailPackingListeDownload = (eventTarget) => {
  let eddlAction = {};

  const clickEventInfo = {
    triggerName: 'orderDetailPackingListeDownload',
    componentType: 'accordion',
    interaction: {
      goal: 'order detail packing list download',
      description: 'Order history - download packing list',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = eventTarget.getAttribute('data-suborderNumber');
  clickEventInfo.interaction.id = eventTarget.getAttribute('data-suborderNumber');

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderDetailRMDDownload = (eventTarget) => {
  let eddlAction = {},
      orderId = '';
  const clickEventInfo = {
    triggerName: 'orderDetailRMDDownload',
    componentType: 'accordion',
    interaction: {
      goal: 'order detail RMD download',
      description: 'Order history - download RMD',
      interactive: true
    }
  };

  orderId = gaclkFn.orderIdfromEventTarget(eventTarget);
  clickEventInfo.interaction.value = eventTarget.textContent.trim();
  clickEventInfo.interaction.id = orderId.trim();
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderDetailRMDPopup = (eventTarget) => {
  let eddlAction = {},
      endText = '';

  if (eventTarget.closest('.prod_info').querySelector('.ph-rmdFlyout').classList.contains('hidden') === false) {
    endText = 'open';
  } else {
    endText = 'close';
  }

  const clickEventInfo = {
    triggerName: `orderDetailRMDPopup${endText}`,
    componentType: 'accordion',
    interaction: {
      goal: `order detail RMD popup ${endText}`,
      description: `Order history - RMD Popup ${endText}`,
      interactive: true
    }
  };

  clickEventInfo.interaction.value = eventTarget.getAttribute('data-productcode');
  clickEventInfo.interaction.id = eventTarget.getAttribute('data-productcode');
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderIdfromEventTarget = function(eventTarget) {
  let orderId = '';

  if (eventTarget.closest(gaclkFn.variables.orderHistoryPanelClass) &&
      eventTarget.closest(gaclkFn.variables.orderHistoryPanelClass)
        .querySelector(gaclkFn.variables.orderHistoryClass)) {
    orderId = eventTarget.closest(gaclkFn.variables.orderHistoryPanelClass)
      .querySelector(gaclkFn.variables.orderHistoryClass).textContent;
  }

  return orderId.trim();
};
gaclkFn.clickOnSort = (eventTarget) => {
  if (eventTarget.parentElement.nodeName === 'DIV') {
    return;
  }

  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'orderhistorySort',
    componentType: 'button',
    interaction: {
      goal: 'Order history sort',
      description: 'Order history sort',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = eventTarget.textContent.trim();
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};
gaclkFn.orderPlacedByMeCheck = (eventTarget) => {
  let endText = '';

  if (eventTarget.checked === 'true') {
    endText = 'me';
  } else {
    endText = 'colleagues';
  }

  let eddlAction = {};
  const clickEventInfo = {
    triggerName: `orderhistoryOrderby${endText}`,
    componentType: 'form',
    interaction: {
      goal: `Order history order by ${endText}`,
      description: `Order history order by ${endText}`,
      interactive: true
    }
  };

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderHistoryCheckbox = (eventTarget) => {
  let endText = '',
      checkedText = '';

  if (eventTarget.className === 'ph-placedByMeCheckbox') {
    endText = 'PlacedByMe';
  } else {
    endText = 'OrderApproval';
  }

  if (eventTarget.checked === true) {
    checkedText = 'checked';
  } else {
    checkedText = 'unchecked';
  }

  let eddlAction = {};
  const clickEventInfo = {
    triggerName: `orderhistory ${endText}${checkedText}`,
    componentType: 'form',
    interaction: {
      goal: `Order history ${endText} ${checkedText}`,
      description: `Order history ${endText} ${checkedText}`,
      interactive: true
    }
  };

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};


gaclkFn.orderPrint = (eventTarget) => {
  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'orderhistoryPrint',
    componentType: 'button',
    interaction: {
      goal: 'Order history print',
      description: 'Order history print',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = gaclkFn.orderIdfromEventTarget(eventTarget);
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};
gaclkFn.orderProductClick = (eventTarget) => {
  let eddlAction = {},
      orderId = '';

  const clickEventInfo = {
    triggerName: 'productClick',
    componentType: 'page',
    interaction: {
      goal: 'order-history product click',
      interactive: true
    }
  };

  /* eslint-disable prefer-destructuring */
  clickEventInfo.interaction.productId = eventTarget.closest('a').href.split('/p/')[1];
  /* eslint-enable prefer-destructuring */

  if (eventTarget.parentElement.classList.contains('ph-os_prodDetails') === true ||
  eventTarget.parentElement.classList.contains('ph-os_prodImg') === true) {
    clickEventInfo.interaction.orderId = eventTarget.parentElement.getAttribute('data-subOrderId');
    clickEventInfo.interaction.productPrice = eventTarget.parentElement.getAttribute('data-productPrice');
  } else {
    orderId = gaclkFn.orderIdfromEventTarget(eventTarget);
    clickEventInfo.interaction.orderId = orderId;
  }

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};
gaclkFn.orderReorderBtnClick = (eventTarget) => {
  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'orderhistoryReorder',
    componentType: 'button',
    interaction: {
      goal: 'Order history reorder',
      description: 'Order reorder',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = gaclkFn.orderIdfromEventTarget(eventTarget);
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};
gaclkFn.orderReturn = (eventTarget) => {
  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'orderhistoryReturnProducts',
    componentType: 'button',
    interaction: {
      goal: 'Order history return products',
      description: 'Order history return products',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = gaclkFn.orderIdfromEventTarget(eventTarget);
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderReorderBtnClickOnestore = (event, properties) => {
  let eddlAction = {};

  const productsArray = gaclkFn.orderHistoryIteration(event, properties);

  eddlAction = gaclkFn.gaProductView(productsArray);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderReturnBtnClickOnestore = (event, properties) => {
  let eddlAction = {};

  const productsArray = gaclkFn.orderHistoryIteration(event, properties);

  eddlAction = gaclkFn.gaProductReturnView(productsArray);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderSmaxBtnClickOnestore = (event, properties) => {
  let eddlAction = {};

  const productsArray = gaclkFn.orderHistoryIteration(event, properties);

  eddlAction = gaclkFn.gaProductSmaxView(productsArray);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderIterationItems = (productDetailItem, value) => {
  const productionArray = [];

  let productObject = [],
      priceValue = '';

  productDetailItem.productList.forEach((productListItem) => {
    const configInfo = [];

    if (productListItem.contractDiscountPrice && productListItem.contractDiscountPrice.formattedValue) {
      priceValue = productListItem.contractDiscountPrice.formattedValue;
    }

    if (productListItem.productCharacteristics !== null || productListItem.productCharacteristics.length > 0) {
      productListItem.productCharacteristics.forEach((productCharacteristics) => {
        configInfo.push(productCharacteristics.value);
      });
    }

    productObject = {
      materialNumber: productListItem.product.code,
      productName: productListItem.product.name,
      quantity: productListItem.quantity,
      price: priceValue,
      subOrderId: value,
      configValue: configInfo
    };
    productionArray.push(productObject);
  });

  return productionArray;
};

gaclkFn.orderHistoryIteration = (eventTarget, properties) => {
  let value = '';
  const productList = [];

  if (eventTarget.target.className === 'ph-smaxLinkHref') {
    value = properties.code;

    if (properties.orderEntries.notShippedEntries.length > 0) {
      properties.orderEntries.notShippedEntries.forEach((productDetailItem) => {
        productList.push(gaclkFn.orderIterationItems(productDetailItem, value));
      });
    }

    if (properties.orderEntries.shippedEntries.length > 0) {
      properties.orderEntries.shippedEntries.forEach((productDetailItem) => {
        productList.push(gaclkFn.orderIterationItems(productDetailItem, value));
      });
    }
  } else {
    properties.entrysPerSalesOrg.forEach((currentItems) => {
      value = currentItems.code;

      if (currentItems.orderEntries.notShippedEntries.length > 0) {
        currentItems.orderEntries.notShippedEntries.forEach((productDetailItem) => {
          productList.push(gaclkFn.orderIterationItems(productDetailItem, value));
        });
      }

      if (currentItems.orderEntries.shippedEntries.length > 0) {
        currentItems.orderEntries.shippedEntries.forEach((productDetailItem) => {
          productList.push(gaclkFn.orderIterationItems(productDetailItem, value));
        });
      }
    });
  }

  return productList;
};

gaclkFn.gaProductView = (productsList) => {
  let eddlAction = '';

  const clickEventInfo = {
    triggerName: 'reorderClick',
    componentType: 'button',
    interaction: {
      goal: 'Reorder button click',
      description: 'Reorder button click',
      interactive: true
    }
  };

  const ecommerEvent = {
    products: productsList
  };

  clickEventInfo.interaction.productsDetailsData = ecommerEvent;
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.gaProductReturnView = (productsList) => {
  let eddlAction = '';

  const clickEventInfo = {
    triggerName: 'returnClick',
    componentType: 'button',
    interaction: {
      goal: 'Return button click',
      description: 'Return button click',
      interactive: true
    }
  };

  const ecommerEvent = {
    products: productsList
  };

  clickEventInfo.interaction.productsDetailsData = ecommerEvent;
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.gaProductSmaxView = (productsList) => {
  let eddlAction = '';

  const clickEventInfo = {
    triggerName: 'smaxClick',
    componentType: 'link',
    interaction: {
      goal: 'Smax Link click',
      description: 'Smax Link click',
      interactive: true
    }
  };

  const ecommerEvent = {
    products: productsList
  };

  clickEventInfo.interaction.url = document.querySelector('.ph-smaxLinkHref').getAttribute('href');
  clickEventInfo.interaction.productsDetailsData = ecommerEvent;
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderTrackClick = (eventTarget) => {
  if (eventTarget.nodeName !== 'A') {
    return;
  }

  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'orderhistoryTrackingURL',
    componentType: 'button',
    interaction: {
      goal: 'Order history tracking url',
      description: 'Order history tracking url',
      interactive: true
    }
  };

  if (eventTarget.className === 'ph-os-trackingUrl') {
    clickEventInfo.interaction.value = eventTarget.getAttribute('data-suborderNumber');
  } else {
    clickEventInfo.interaction.value = gaclkFn.orderIdfromEventTarget(eventTarget);
  }

  clickEventInfo.interaction.url = eventTarget.href;
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.orderApproval = (eventTarget) => {
  let eddlAction = {},
      endText = '',
      orderId = '';

  if (eventTarget.getAttribute('data-decision') === 'APPROVE') {
    endText = 'approve';
  } else if (eventTarget.getAttribute('data-decision') === 'REJECT') {
    endText = 'reject';
  }

  const clickEventInfo = {
    triggerName: 'orderApproval',
    componentType: 'button',
    interaction: {
      goal: 'Order approval',
      description: `Order approval ${endText}`,
      interactive: true
    }
  };

  orderId = gaclkFn.orderIdfromEventTarget(eventTarget);
  clickEventInfo.interaction.value = orderId.trim();
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};
gaclkFn.orderHistorySearchOrder = (searchValue) => {
  let eddlAction = {};
  const clickEventInfo = {
    triggerName: 'orderHistorySearch',
    componentType: 'form',
    interaction: {
      goal: 'order History search',
      description: 'Order history - Search',
      interactive: true
    }
  };

  clickEventInfo.interaction.value = searchValue;
  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};

gaclkFn.findIndexofChild = (childNode) => {
  return $(childNode).index();
};

gaclkFn.searchOrderform = function() {
  let status = ' ',
      productCount = null;
  const formClassName = 'searchOrderForm',
      clickEventInfo = {
        triggerName: 'orderSearchFormSubmit',
        componentType: 'form',
        interaction: {
          goal: 'order search form submit',
          description: 'Order search',
          interactive: true
        }
      };

  document.addEventListener('submit', (eventFired) => {
    if (eventFired.target && eventFired.target.closest(`#${formClassName}`)) {
      sessionStorage.setItem('searchOrderClick', true);
    }
  });

  if (sessionStorage.getItem('searchOrderClick') === 'true') {
    if (document.querySelector('.prod_refine') === null) {
      status = 'error';
    } else {
      productCount = document.querySelector('.prod_refine').getAttribute('data-count');
      status = 'success';
    }


    clickEventInfo.interaction.status = status;
    clickEventInfo.interaction.value = productCount;
    window.eddlEvents = window.eddlEvents || [];

    let eddlAction = {};

    eddlAction = window.gaObject.interactionEvent(clickEventInfo);
    window.eddlEvents.push(eddlAction);
    sessionStorage.removeItem('searchOrderClick');
  }
};

gaclkFn.warrentySearchform = function() {
  let status = ' ',
      searchTxt = null;
  const formClassName = 'warrantySearchForm',
      clickEventInfo = {
        triggerName: 'warrantySearchFormSubmit',
        componentType: 'form',
        interaction: {
          goal: 'Warranty search form submit',
          description: 'Warranty search',
          interactive: true
        }
      };

  document.addEventListener('submit', (eventFired) => {
    if (eventFired.target && eventFired.target.closest(`#${formClassName}`)) {
      sessionStorage.setItem('wareentysearchClick', true);
    }
  });

  if (sessionStorage.getItem('wareentysearchClick') === 'true') {
    if (document.querySelector('.ph-account_warrantydetails_page') === null) {
      status = 'error';
    } else {
      status = 'success';
    }

    searchTxt = document.querySelector('.ph-serialentry').value;

    clickEventInfo.interaction.status = status;
    clickEventInfo.interaction.value = searchTxt;
    window.eddlEvents = window.eddlEvents || [];

    let eddlAction = {};

    eddlAction = window.gaObject.interactionEvent(clickEventInfo);

    window.eddlEvents.push(eddlAction);
    sessionStorage.removeItem('wareentysearchClick');
  }
};

gaclkFn.osThankYouPageClickHere = () => {
  document.querySelector('.ph-orderConfirmation__sectionOne--Description a').addEventListener('click', (event) => {
    window.eddlEvents = window.eddlEvents || [];

    let eddlAction = {};

    const clickEventInfo = {
      triggerName: 'ThankYouPageClickHere',
      componentType: 'link',
      interaction: {
        goal: 'Thank you page Go here link',
        description: 'Go here link',
        interactive: true
      }
    };

    clickEventInfo.interaction.status = 'success';
    clickEventInfo.interaction.url = event.target.getAttribute('href');

    eddlAction = window.gaObject.interactionEvent(clickEventInfo);
    window.eddlEvents.push(eddlAction);
  });
};

gaclkFn.osThankYouPageViewOrder = () => {
  document.querySelector('.ph-orderConfirmation__button--viewOrder').addEventListener('click', (event) => {
    window.eddlEvents = window.eddlEvents || [];

    let eddlAction = {};

    const clickEventInfo = {
      triggerName: 'ThankYouPageViewOrder',
      componentType: 'link',
      interaction: {
        goal: 'Thank you page View Order link',
        description: 'View Order link',
        interactive: true
      }
    };

    clickEventInfo.interaction.status = 'success';
    clickEventInfo.interaction.url = event.target.getAttribute('href');

    eddlAction = window.gaObject.interactionEvent(clickEventInfo);
    window.eddlEvents.push(eddlAction);
  });
};
gaclkFn.anonymousAddToCart = (url) => {
  window.eddlEvents = window.eddlEvents || [];

  let eddlAction = {};

  const clickEventInfo = {
    triggerName: 'anonymousAddToCart',
    componentType: 'button',
    interaction: {
      goal: 'Anonymous Add To Cart PLP',
      description: 'Anonymous Add To Cart PLP',
      interactive: true
    }
  };

  clickEventInfo.interaction.status = 'success';
  clickEventInfo.interaction.url = url;

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
};
gaclkFn.gaButtonClicks = (input) => {
  window.eddlEvents = window.eddlEvents || [];

  let eddlAction = {},
      pageValue = '',
      inputCombined = 'button';
  const {pageName, pageType} = window.eddlContext.page;

  if (pageName) {
    pageValue = pageName;
  } else {
    pageValue = pageType;
  }

  if (input.triggerType && input.sectionValue && input.linkValue) {
    inputCombined = `${input.triggerType}:${input.sectionValue}:${input.linkValue}`;
  } else if (input.triggerType && input.sectionValue) {
    inputCombined = `${input.triggerType}:${input.sectionValue}`;
  } else if (input.triggerType) {
    inputCombined = `${input.triggerType}`;
  }

  const clickEventInfo = {
    triggerName: `${input.triggerType}:${input.sectionValue}`,
    eventValue: 'generic events',
    componentType: input.triggerType,
    interaction: {
      goal: inputCombined,
      description: `${pageValue}:interaction:${inputCombined}`,
      interactive: true
    }
  };

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
  window.ACC.omniture.bindTrackConversion('interaction', inputCombined);
};
gaclkFn.linksTextFilter = (element, sectionValue, currentEvent) => {
  let linktext = currentEvent.target.textContent;

  if (sectionValue === 'recent_orders' && element.querySelector('.ph-order_code')) {
    linktext = element.querySelector('.ph-order_code').textContent;
  }

  if (sectionValue === 'saved_lists' && element.querySelector('.ph-homepagesavedlist__wishlistname')) {
    linktext = element.querySelector('.ph-homepagesavedlist__wishlistname').textContent;
  }

  if (linktext) {
    linktext = linktext.trim();
  }

  return linktext;
};
gaclkFn.linksOnclickGaEvent = (elementClass, sectionValue) => {
  [...document.querySelectorAll(elementClass)].forEach((element) => {
    return element.addEventListener('click', (currentEvent) => {
      window.eddlEvents = window.eddlEvents || [];

      let eddlAction = {},
          pageValue = '',
          linkValue = sectionValue,
          inputCombined = '';
      const {pageName, pageType} = window.eddlContext.page;

      if (pageName) {
        pageValue = pageName;
      } else {
        pageValue = pageType;
      }

      const linktext = gaclkFn.linksTextFilter(element, sectionValue, currentEvent);

      if (linktext) {
        linkValue = linktext.replace(/ /g, '_');
      }

      if (sectionValue && linkValue && sectionValue !== linkValue) {
        inputCombined = `${sectionValue}:${linkValue}`;
      } else if (sectionValue) {
        inputCombined = `${sectionValue}`;
      }

      const clickEventInfo = {
        triggerName: `link:${sectionValue}`,
        eventValue: 'generic events',
        componentType: 'link',
        interaction: {
          goal: `link:${inputCombined}`,
          description: `${pageValue}:interaction:link:${inputCombined}`,
          interactive: true
        }
      };

      eddlAction = window.gaObject.interactionEvent(clickEventInfo);
      window.eddlEvents.push(eddlAction);
      window.ACC.omniture.bindTrackConversion('interaction', clickEventInfo.triggerName);
    });
  });
};
gaclkFn.productSearchform = function() {
  let status = 'fail',
      searchTxt = '';
  const clickEventInfo = {
    triggerName: 'search-results',
    componentType: 'form',
    interaction: {
      goal: 'Product search',
      description: 'Product search form submit',
      interactive: true
    }
  };

  if (document.querySelector('.ph-page-searchEmpty')) {
    status = 'fail';
  }

  if (document.querySelector('.ph-page-search')) {
    status = 'success';
  }

  if (document.querySelector('meta[name="PHILIPS.METRICS.SEARCHKEYWORD"]')) {
    searchTxt = document.querySelector('meta[name="PHILIPS.METRICS.SEARCHKEYWORD"]').content;
  }

  clickEventInfo.interaction.status = status;

  if (searchTxt) {
    clickEventInfo.triggerName = `search-results:${searchTxt}`;
  }

  clickEventInfo.interaction.value = searchTxt;
  window.eddlEvents = window.eddlEvents || [];

  let eddlAction = {};

  eddlAction = window.gaObject.interactionEvent(clickEventInfo);
  window.eddlEvents.push(eddlAction);
  window.ACC.omniture.bindTrackConversion('interaction', clickEventInfo.triggerName);
};
gaclkFn.interactionClickTracking = () => {
  const interactionTrackingElements = document.querySelectorAll('.ga-interactionTracking');

  interactionTrackingElements.forEach((interactionTrackingElement) => {
    interactionTrackingElement.addEventListener('click', (event) => {
      window.eddlEvents = window.eddlEvents || [];

      let eddlAction = {},
          triggerAction = 'buttonClick',
          componentType = 'button',
          descriptionValue = 'button:click';
      const {pageName} = window.eddlContext.page;

      if (event.target.tagName && event.target.tagName.toLowerCase() === 'a') {
        triggerAction = 'linkClick';
        componentType = 'link';
        descriptionValue = 'link:click';
      }

      if (pageName) {
        descriptionValue = `${pageName}:${descriptionValue}`;
      }

      if (interactionTrackingElement.getAttribute('ga-description')) {
        let desc = interactionTrackingElement.getAttribute('ga-description');

        descriptionValue = desc;
        descriptionValue = descriptionValue.replaceAll(' ', '_').toLowerCase();

        if (pageName && desc.includes('page:')) {
          desc = desc.replace('page:', '');
          descriptionValue = `${pageName}:${desc}`;
        }
      }

      const clickEventInfo = {
        triggerName: triggerAction,
        componentType,
        interaction: {
          goal: 'interaction',
          description: descriptionValue,
          interactive: true
        }
      };

      if (interactionTrackingElement.getAttribute('ga-url')) {
        clickEventInfo.interaction.url = interactionTrackingElement.getAttribute('ga-url');
      }

      eddlAction = window.gaObject.interactionEvent(clickEventInfo);
      window.eddlEvents.push(eddlAction);
    });
  });
};
gaclkFn.servicemenuClick = () => {
  const spsMenuLink = '.ph-subnavigation .ph-headerparent__navichild a, .ph-hamburger__menu .ph-headerparent__navimobileparent a';

  $(spsMenuLink).each(function() {
    const linktext = $.trim($(this).text()).replaceAll(' ', '_').toLowerCase();

    $(this).addClass('ga-interactionTracking').attr('ga-description', `link:${linktext}`);
  });
};

(function() {
  document.addEventListener('DOMContentLoaded', () => {
    window.gaclkFn.searchOrderform();
    window.gaclkFn.warrentySearchform();
    window.gaclkFn.servicemenuClick();
    window.gaclkFn.interactionClickTracking();


    if (document.querySelectorAll('.ph-page-orderConfirmationPage').length > 0) {
      window.gaclkFn.osThankYouPageClickHere();
      window.gaclkFn.osThankYouPageViewOrder();
    }
  });
})();
/* eslint-enable max-lines */
